module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg5@3x.87b7b0a2.png";